import type { LaborLineEdits, LaborLineItemsResponse, LaborRowItem } from "../types";
import { sortLaborRowsByDisplayOrder } from "./laborDisplayOrder";

const DEFAULT_LABOR_GROUP = "Uncategorized";

export function mapLaborLineItemsResponse(
    res: LaborLineItemsResponse,
): LaborRowItem[] {
    const rows = res.map((row) => ({
        id: row.Id,
        laborServiceId: row.LaborServiceId,
        name: row.Name,
        unit: row.Unit,
        category: row.Category || null,
        categoryGroup: row.CategoryGroup || DEFAULT_LABOR_GROUP,
        quantity: row.Quantity === null ? 0 : row.Quantity,
        priceRange: row.PriceRange,
    }));

    return sortLaborRowsByDisplayOrder(rows);
}

export function groupLaborRowsByCategoryGroup(
    laborRows: LaborRowItem[],
): Record<string, LaborRowItem[]> {
    const grouped: Record<string, LaborRowItem[]> = {};

    for (const row of laborRows) {
        const groupName = row.categoryGroup?.trim() || DEFAULT_LABOR_GROUP;
        if (!grouped[groupName]) {
            grouped[groupName] = [];
        }
        grouped[groupName].push(row);
    }

    return grouped;
}

export function buildLaborEditsFromRows(
    laborRows: LaborRowItem[],
): LaborLineEdits {
    const edits: LaborLineEdits = {};

    for (const row of laborRows) {
        edits[row.id] = {
            laborServiceId: row.laborServiceId,
            quantity: row.quantity,
            supplierUnitPrice: null,
            supplierId: null,
            supplierName: null,
        };
    }

    return edits;
}
